import { render, staticRenderFns } from "./GroupMemberItem.vue?vue&type=template&id=2b9c7ab4"
import script from "./GroupMemberItem.vue?vue&type=script&lang=js"
export * from "./GroupMemberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports